<svelte:head>

    <link rel="stylesheet" type="text/css" href="/global.css" />
    <link rel="stylesheet" type="text/css" href="css/forms.css" />

</svelte:head>

<script>

    import { onMount } from "svelte";
    import { getContext } from "svelte";
    import { fade } from 'svelte/transition';
    import PropertyIntegrations from "../admin/integrations.svelte";

    import {
        errorReasons,
        updateUserStatus,
        getProperty,
        listProperties,
        integrationDelete,
        tripadvisorSet,
        googleSet,
        facebookSet, logout
    } from "../api.svelte";

    import {
        getLocalSessionId,
        getLocalUserStatus,
        getLocalPropertyId,
        getStatusRoute, sessionCleanup
    } from "../../utils/session";
    import {sessionId} from "../../utils/store";


    const ERROR_DISAPPEAR_AFTER = 5500;


    const router = getContext('router');

    let propertyId = getLocalPropertyId();

    let property = false;
    let currentView = 'integrations';
    let integrationsError = false;
    let resetTimer = null;


    onMount(() => {

        let localSessionId = getLocalSessionId();
        let localStatus = getLocalUserStatus();

        if (!localSessionId || !localStatus) {

            router.route('/login');
            return;

        }

        if (localStatus !== 'onboarding_integrations') {

            router.route(getStatusRoute(localStatus));
            return;
        }

        // PropertyId is not saved in local storage, have to fetch it
        if (!propertyId) {

            listProperties().then((listResult) => {

                if (listResult['status'] !== 'success') {

                    // TODO: Handle errore
                    console.log(listResult);
                    return;

                }

                propertyId = Object.keys(listResult['properties'])[0];

                property = listResult['properties'][propertyId];

            });

            return;

        }

        getProperty(propertyId).then((propertyResult) => {

            if (propertyResult['status'] !== 'success') {

                integrationsError = propertyResult['reason'];
                startResetTimer();

                return;

            }

            property = propertyResult['property'];

        });

    });

    let startResetTimer = () => {

        if (resetTimer) {

            clearTimeout(resetTimer);
        }

        resetTimer = setTimeout(() => {

            integrationsError = false;

        }, ERROR_DISAPPEAR_AFTER);

    };

    let switchView = (view) => {

        currentView = view;
    };

    let viewChangedHandler = (evt) => {

        switchView(evt.detail['id']);
    };

    let integrationClickedHandler = (evt) => {

        if ((Object.keys(property['integrations']).length === property['maxintegrations'])
            && (!Object.keys(property['integrations']).includes(evt.detail['id']))) {

            integrationsError = 'max_integrations';
            startResetTimer();

            return;

        }

        switchView(evt.detail['id']);

    };

    let deleteIntegrationHandler = (evt) => {

        integrationDelete(propertyId, evt.detail['integration']).then((deleteResult) => {

            if (deleteResult['status'] !== 'success') {

                integrationsError = deleteResult['reason'];
                startResetTimer();

                return;

            }

            let updatedIntegrations = {};

            for (const [integrationKey, integration] of Object.entries(property['integrations'])) {

                if (integrationKey !== evt.detail['integration']) {

                    updatedIntegrations[integrationKey] = integration;
                }

            }

            property['integrations'] = updatedIntegrations;

        });

    };

    let integrationSelectedHandler = (evt) => {

        const details = evt.detail['details'];

        switch (evt.detail['id']) {

            case 'tripadvisor':

                tripadvisorSelected(details);
                break;

            case 'google':

                googleSelected(details);
                break;

            case 'facebook':

                facebookSelected(details);
                break;

        }

    };

    let tripadvisorSelected = (details) => {

        tripadvisorSet(propertyId, details['name'],
            details['address'], details['url']).then((setResult) => {

            if (setResult['status'] !== 'success') {

                integrationsError = setResult['reason'];
                startResetTimer();

                return;

            }

            property['integrations']['tripadvisor'] = setResult['integration'];

        });

    };

    let googleSelected = (details) => {

        let location = {
            'id': details['id'],
            'placeid': details['placeid'],
            'name': details['name'],
            'address': details['address'],
            'account': details['account']
        };

        googleSet(propertyId, location).then((setResult) => {

            if (setResult['status'] !== 'success') {

                integrationsError = setResult['reason'];
                startResetTimer();

                return;

            }

            property['integrations']['google'] = setResult['integration'];

        });

    };

    // TODO: Finish testing and setFacebook
    let facebookSelected = (details) => {

        console.log('facebook selected');

    };

    let integrationsHandler = (evt) => {

        if (Object.keys(property['integrations']).length < 1) {

            integrationsError = 'no_integrations';
            startResetTimer();

            return;

        }

        localStorage.setItem('kstatus', 'onboarding_collecting');
        updateUserStatus('onboarding_collecting');

        router.route('/collecting');

    };

    let logoutHandler = () => {

        logout().then((_) => {

            sessionId.set('');
            sessionCleanup();
            router.route('/login');

        });

    };

</script>


<div class="onboarding-logout" on:click={() => logoutHandler()}>

    <img src="/images/icons/nav/logout.svg" alt="">
    <span>Logout</span>

</div>

<div class="onboarding-text">

    <div class="headline-styler"></div>

    <h2>
        Portale verknüpfen.
    </h2>

    <ul class="keyosh-list">

        <li>
            Hier verbinden Sie die Bewertungsportale mit der Intelligenz von keyosh.
        </li>

        <li>
            Wählen Sie einfach die gewünschten Portale und melden Sie sich einmalig an.
        </li>

        <li>
            Ab diesem Moment wird keyosh die Bewertungen für Ihren Betrieb analysieren
            und Ihnen viele neue Erkenntnisse bringen.
        </li>

    </ul>

</div>

<div id="integrations-container" class="forms-container">

    <PropertyIntegrations
            propertyId={propertyId}
            propertyData={property}
            currentView={currentView}
            integrationsError={integrationsError}
            showSubtitle={true}
            showButton={true}
            on:view={viewChangedHandler}
            on:clicked={integrationClickedHandler}
            on:deleted={deleteIntegrationHandler}
            on:selected={integrationSelectedHandler}
            on:submitted={integrationsHandler} />

</div>


<style>

    .onboarding-text {
        margin-right: 21.66vh;
    }

    @media screen and (max-width: 1024px) {

        .onboarding-text {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            width: 86vw;
            margin-top: 6vw;
            margin-right: 0;
        }

        #integrations-container {
            margin-top: 8vw;
        }

    }

</style>
